import styled from "styled-components";

export const WrapperCardShoppingRow = styled.div``;
interface IContainerProps {
	$isRecommended?: boolean;
}
export const ContainerCardShoppingRow = styled.div<IContainerProps>`
	display: flex;
	align-items: center;
	width: 100%;
	height: 90px;
	border: 1px solid ${({ $isRecommended, theme }) => ($isRecommended ? theme.pantone2726C : "#ebebeb")};
	> .products-list__column {
		height: 100%;
		border-right: 1px solid #ebebeb;

		&:last-child {
			border: none;
		}
	}
`;
